/* globals _refersion */

if (window._refersion) {
  _refersion()
}
